import MetadataDefinitions from '@/shared/types/metadata/metadataDefinitions.type';
import Response from '@/shared/types/response';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type CreateMetadataErrorResponse = Response<{
  metadata_key: string;
  level: string;
  item?: MetadataDefinitions & { level?: string };
}>;

const createMetadata = async (body: object[], onUnauthorized?: () => void) => {
  const token = getCookie('auth_token');
  const chunksIds = chunkArray(body, 5);

  const results: Response<object | CreateMetadataErrorResponse>[] = [];

  for (const chunk of chunksIds) {
    const promises = chunk.map((item) => {
      const {
        metadata_key,
        metadata_description,
        metadata_category,
        metatype_id,
        level_constraint,
        level,
      } = item as MetadataDefinitions & { level?: string };

      return fetcher<Response<object>>({
        url: '/products/metadata/create/',
        method: 'POST',
        body: {
          metadata_key,
          metadata_description,
          metadata_category,
          metatype_id,
          level_constraint,
        },
        retries: 3,
        token,
        onUnauthorized,
      }).catch((error) => {
        console.error(
          'Error occurred in function "createMetadata" in file "src/shared/api/product/createMetadata.ts":',
          error,
        );

        return {
          ...error,
          data: { metadata_key, level, item },
        } as CreateMetadataErrorResponse;
      });
    });

    const chunkResults = await Promise.all(promises);
    results.push(...chunkResults);
  }

  return results;
};

export default createMetadata;
